import "./i18n";
import "./api";
import "react-toastify/dist/ReactToastify.min.css";

import LuxonUtils from "@date-io/luxon";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import AdapterLuxon from "@mui/lab/AdapterLuxon";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import * as Sentry from "@sentry/react";
import { ConnectedRouter } from "connected-react-router";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { sentryConfig } from "sentry";
import * as yup from "yup";

import App from "./App";
import { initializeFeatureFlags } from "./feature-flags";
import store, { history, persistor } from "./store";
import * as yupHelpers from "./utils/yup";

import type { AppWindow } from "./appWindow";

declare let window: AppWindow;

let ProfiledApp: React.FC = App;

const environment = process.env.REACT_APP_ENV || "local";

if (environment !== "local" && process.env.REACT_APP_SENTRY_URL) {
  Sentry.init(sentryConfig(environment, history));

  ProfiledApp = Sentry.withProfiler(App);
}

// expose store to dev, ex: Cypress
if (environment !== "prod") {
  window.store = store;
}

initializeFeatureFlags();

yup.setLocale(yupHelpers.yupLocale);

const container = document.getElementById("root");

if (!container) {
  throw new Error("Not found root element");
}

const root = createRoot(container);

root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <ConnectedRouter history={history}>
        <MuiPickersUtilsProvider utils={LuxonUtils}>
          <LocalizationProvider dateAdapter={AdapterLuxon} locale="en">
            <ProfiledApp />
          </LocalizationProvider>
        </MuiPickersUtilsProvider>
      </ConnectedRouter>
    </PersistGate>
  </Provider>
);
